import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const DI2026 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className='container-full-width'
      style={{
        backgroundImage: `url('https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/DI2026.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <div className='row'>
        <div className='col-12'>

          <h3 
            className='title'
            style={{ 
              color: 'white',
              fontWeight: 'bold',
              textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
              textAlign: 'center'
            }}
          >
            Construyendo un Futuro Inclusivo
          </h3>

          <div className="hero">

            <h4>
           Impulsamos el desarrollo integral, económico y social de la comunidad
              LGBTTTIQ+ mediante programas de apoyo, capacitación y bienestar.
            </h4>

            <h3>¡Conoce la convocatoria, descarga el formato y regístrate!</h3>

            {/* Contenedor para botones */}
            <div className="botones">
              <a 
                href="/documento/28" 
                className="btn-vino"
              >
                Convocatoria
              </a>

              <a 
                href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2026/AM/FUPS_2026.pdf" 
                className="btn-vino"
              >
                Formato
              </a>

              <a 
                href="https://forms.gle/B63dh8PYjod5ZU8V7" 
                className="btn-vino"
              >
                Registro
              </a>
            </div>

          </div>

          <hr className='hr-gob' />

        </div>
      </div>
    </div>
  );
};

export default DI2026;